import { render, staticRenderFns } from "./zMenuImprimir.vue?vue&type=template&id=1f000bfd&scoped=true&"
import script from "./zMenuImprimir.vue?vue&type=script&lang=js&"
export * from "./zMenuImprimir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f000bfd",
  null
  
)

export default component.exports